import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c0b9060"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c0b9060&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0b9060')) {
      api.createRecord('4c0b9060', component.options)
    } else {
      api.reload('4c0b9060', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c0b9060", function () {
      api.rerender('4c0b9060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHive/index.vue"
export default component.exports